import { useCallback, useEffect, useState } from 'react';
import {
  getSelectedCurrency,
  getEurToGbpRate,
  convertFromEur,
  formatMoney,
  formatFromEur,
} from './currency';

const readCurrency = () => getSelectedCurrency();
const readRate = () => getEurToGbpRate();

export const useCurrency = () => {
  const [currency, setCurrency] = useState(readCurrency());
  const [rate, setRate] = useState(readRate());

  useEffect(() => {
    const sync = (event) => {
      const nextCurrency = event?.detail?.currency || readCurrency();
      const nextRate = event?.detail?.rate ?? readRate();
      setCurrency(nextCurrency);
      setRate(nextRate);
    };
    window.addEventListener('currency-change', sync);
    window.addEventListener('currency-rate-update', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('currency-change', sync);
      window.removeEventListener('currency-rate-update', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  /** @param {number} amount @param {string=} overrideCurrency */
  const formatAmount = useCallback(
    (amount, overrideCurrency) => formatMoney(amount, overrideCurrency || currency),
    [currency],
  );

  const formatAmountFromEur = useCallback(
    (amount) => formatFromEur(amount, currency, rate),
    [currency, rate],
  );

  const convertAmountFromEur = useCallback(
    (amount) => convertFromEur(amount, currency, rate),
    [currency, rate],
  );

  return {
    currency,
    rate,
    setCurrency: (next) => {
      const value = next || 'EUR';
      localStorage.setItem('currency', value);
      window.dispatchEvent(new CustomEvent('currency-change', { detail: { currency: value } }));
    },
    formatAmount,
    formatFromEur: formatAmountFromEur,
    convertFromEur: convertAmountFromEur,
  };
};
